/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
export function s(item) {
  switch (item) {
      case "":
          return "";
      case "1":
          return "合格";
      case "2":
          return "质检不合格";
      case "3":
          return "质检放行剔除";
      case "4":
          return "质检灭菌消耗";
      case "5":
          return "生产放行未打印标签";
    default:
      return "数据异常";
  }
}
